import React from 'react'
import styles from "./Input.module.scss"
import { Controller } from 'react-hook-form'
import withLabelAndError from '../withLabelAndError'

const Input = (props) => {
    const { control, register, validations, label, name, icon, placeholder, isRequired, type, ...rest } = props
    
    if(!register) {
        return <Controller
            control={control}
            rules={validations}
            name={name}
            render={({ field }) => (
                <input
                    {...field}
                    {...rest}
                    id={name}
                    type={type || "text"} 
                    className={props?.className || styles.inputField}
                    placeholder={placeholder}
                />
            )}
        />
    }else {
        const field = register(name, validations)
        return <input
            {...field}
            {...rest}
            id={name}
            name={name}
            type={type || "text"}
            className={props?.className || styles.inputField}
            placeholder={placeholder}
        />
    }
}

export default withLabelAndError(Input)
export { Input }